import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Upload {
  id: string;
  fileName: string;
  progress: number;
  status: 'uploading' | 'completed' | 'failed';
  error?: string;
  createdAt: number;
}

interface UploadState {
  uploads: Upload[];
}

const initialState: UploadState = {
  uploads: [],
};

const uploadSlice = createSlice({
  name: 'uploads',
  initialState,
  reducers: {
    addUpload: (state, action: PayloadAction<Upload>) => {
      state.uploads.push(action.payload);
    },
    updateUpload: (
      state,
      action: PayloadAction<{ id: string; updates: Partial<Upload> }>
    ) => {
      const upload = state.uploads.find((u) => u.id === action.payload.id);
      if (upload) {
        Object.assign(upload, action.payload.updates);
      }
    },
    removeUpload: (state, action: PayloadAction<string>) => {
      state.uploads = state.uploads.filter((u) => u.id !== action.payload);
    },
    clearCompleted: (state) => {
      state.uploads = state.uploads.filter((u) => u.status !== 'completed');
    },
  },
});

export const { addUpload, updateUpload, removeUpload, clearCompleted } =
  uploadSlice.actions;
export const uploadReducer = uploadSlice.reducer;

// Store XHR and AbortControllers outside Redux (not serializable)
export const xhrStore = new Map<string, XMLHttpRequest>();
export const abortControllerStore = new Map<string, AbortController>();
